const state = {
  dataTableOptions: {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: 25,
    multiSort: true,
    mustSort: false,
    page: 1,
    sortBy: ["node.email"],
    sortDesc: [false],
  },
  search: null,
  selectedGroupPks: null,
  selectedTenant: null,
  selectedPartner: null,
};

const mutations = {
  SET_DATA_TABLE_OPTIONS(state, payload) {
    state.dataTableOptions = payload;
  },

  SET_SEARCH(state, payload) {
    state.search = payload;
  },

  SET_SELECTED_GROUP_PKS(state, payload) {
		state.selectedGroupPks = payload;
	},

  SET_SELECTED_TENANT(state, payload) {
    state.selectedTenant = payload;
  },

  SET_SELECTED_PARTNER(state, payload) {
    state.selectedPartner = payload;
  },
};

const actions = {
  setDataTableOptions(context, payload) {
    context.commit("SET_DATA_TABLE_OPTIONS", payload);
  },

  setSearch(context, payload) {
    context.commit("SET_SEARCH", payload);
  },

  setSelectedGroupPks(context, payload) {
		context.commit("SET_SELECTED_GROUP_PKS", payload);
	},

  setSelectedTenant(context, payload) {
    context.commit("SET_SELECTED_TENANT", payload);
  },

  setSelectedPartner(context, payload) {
    context.commit("SET_SELECTED_PARTNER", payload);
  },
};

const getters = {
  getDataTableOptions(state) {
    return state.dataTableOptions;
  },

  getSearch(state) {
    return state.search;
  },

  getSelectedGroupPks(state) {
		return state.selectedGroupPks;
	},

  getSelectedTenant(state) {
    return state.selectedTenant;
  },

  getSelectedPartner(state) {
    return state.selectedPartner;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
